module.exports = __webpack_public_path__ + "img/pic-pubg.1e8e884.png";